import axios from 'axios';

export type ApiResponse<T> = {
    data: T;
    status: number
};

export type ApiError = {
    message: string;
    config?: {
        url?: string;
    },
    request?: {
        status?: number;
    }
};

type PostArgs<T> = {
    url: string;
    payload?: T
}

type RequestHeaders = {
    RequestVerificationToken?: string
    'Content-Type': string
}

export const getCsrfToken = () : string | null => {
    const element = document.getElementsByName(
        '__RequestVerificationToken',
    )[0] as HTMLInputElement;

    if (element) {
        return element.value;
    }
    /* istanbul ignore next */
    if(process.env.NODE_ENV === 'development') {
        console.log('__RequestVerificationToken does\'t exist');
    }

    return null;
};

export const createHeaders = () : RequestHeaders => {
    const headers = { 'Content-Type': 'application/json' };

    const token = getCsrfToken();

    if (token) {
        return {
            ...headers,
            RequestVerificationToken: token,
        };
    }

    return headers;
};

export const get = <T> (url: string) : Promise<ApiResponse<T>> => (
    new Promise((resolve, reject) => {
        axios.get(url)
            .then((res: ApiResponse<T>) => {
                resolve(res);
            })
            .catch((error:ApiError) => {
                reject(error);
            });
    })
);

export const del = <T> (url: string) : Promise<ApiResponse<T>> => (
    new Promise((resolve, reject) => {
        axios.delete(url, { headers: createHeaders() })
            .then((res: ApiResponse<T>) => {
                resolve(res);
            })
            .catch((error:ApiError) => {
                reject(error);
            });
    })
);

export const post = <T1, T2> ({
    url,
    payload,
}: PostArgs<T2>) : Promise<ApiResponse<T1>> => (
        new Promise((resolve, reject) => {
            axios.post(url, payload, { headers: createHeaders() })
                .then((res: ApiResponse<T1>) => {
                    resolve(res);
                })
                .catch((error:ApiError) => {
                    reject(error);
                });
        })
    );

export const put = <T1, T2> ({
    url,
    payload,
}: PostArgs<T2>) : Promise<ApiResponse<T1>> => (
        new Promise((resolve, reject) => {
            axios.put(url, payload, { headers: createHeaders() })
                .then((res: ApiResponse<T1>) => {
                    resolve(res);
                })
                .catch((error:ApiError) => {
                    reject(error);
                });
        })
    );

